// Utilitário de permissões para o frontend
// Avalia permissões efetivas retornadas pelo backend e aplica fallback por role

/**
 * Verifica se o usuário possui uma permissão específica.
 *
 * @param {Object} effectivePermissions - Mapa de permissões efetivas, ex: { canManageProjects: true }
 * @param {string} userRole - Papel do usuário (ex: 'ADM', 'GERENCIAL', 'DEV', 'QA', 'ADMIN')
 * @param {string} key - Chave da permissão a verificar
 * @param {string[]} fallbackRoles - Lista de roles que concedem a permissão quando não houver definição explícita
 * @returns {boolean}
 */
export const hasPermissionUtil = (effectivePermissions = {}, userRole = '', key, fallbackRoles = []) => {
  if (!key) return false;
  // Checar permissão explícita
  if (effectivePermissions && typeof effectivePermissions === 'object') {
    const value = effectivePermissions[key];
    if (value === true) return true;
    if (value === false) return false;
  }

  // Normalizar roles legados para os canônicos usados no frontend
  const rawUpper = (userRole || '').toUpperCase();
  const normalizedRole =
    rawUpper === 'ADMIN' || rawUpper === 'ADM' ? 'ADM' :
    rawUpper === 'MANAGER' || rawUpper === 'GERENCIAL' ? 'GERENCIAL' :
    rawUpper === 'TRIAL' ? 'GERENCIAL' :
    rawUpper === 'UNITARIO' ? 'GERENCIAL' :
    rawUpper === 'TESTER' || rawUpper === 'QA' ? 'QA' :
    rawUpper === 'DEVELOPER' || rawUpper === 'DESIGNER' || rawUpper === 'DEV' ? 'DEV' :
    rawUpper === 'VIEWER' || rawUpper === 'CONSULTA' || rawUpper === 'READONLY' ? 'DEV' :
    rawUpper;

  // Fallback por role (aplica com role normalizado)
  const fallbackUpper = fallbackRoles.map(r => (r || '').toUpperCase());
  if (fallbackUpper.includes(normalizedRole)) {
    return true;
  }
  return false;
};
